/**
 * GALATEA SIGNATURE - OVERRIDE REGIONAL: URUGUAY (es-UY)
 */

export const esUYOverride = {
  entities: {
    document: 'RUT / CI',
    state: 'Departamento',
    fiscal: 'Información DGI / CFE',
  },
};

export default esUYOverride;
